import { z } from 'zod/v4';

export const RawDataFileSchema = z.object({
  fileId: z.string(),
  fileName: z.string(),
  mimeType: z.string(),
});

export const RawDataStyleSchema = z.object({
  name: z.string(),
  styleId: z.string(),
  styleCodes: z.array(z.string()),
});

export const RawDataSchema = z.object({
  files: z.array(RawDataFileSchema),
  styles: z.array(RawDataStyleSchema),
});

export type RawDataFileType = z.infer<typeof RawDataFileSchema>;
export type RawDataStyleType = z.infer<typeof RawDataStyleSchema>;
export type RawDataType = z.infer<typeof RawDataSchema>;
